import { fetchAllVideos } from '../services/videoService';

export function format(first?: string, middle?: string, last?: string): string {
  return (first || '') + (middle ? ` ${middle}` : '') + (last ? ` ${last}` : '');
}

export async function getAllVideos(clientId: string, baseUrl: string = 'https://media-ingestion.antino.ca') {
  if (!clientId) {
    console.error('client id is required');
  }
  try {
    return await fetchAllVideos(clientId, baseUrl);
  } catch (error) {
    console.error('Error fetching all videos:', error);
  }
}
